
// Constants
import { APP_CONFIG } from '../constants';

// helpers
import { decodeTokenBody } from '../helpers';

/**
 * Extrae la información del token de autorización del usuario para la API
 * @param { String } accessToken Access Token de la api
 */
export const extractTokenAuthorization = (accessToken) => {

    const accessConfig = decodeTokenBody(accessToken);
    const metadata = accessConfig[APP_CONFIG.API.AUTH.USER_INFO.METADATA_PREFIX];    

    return {

        metadata,
        permissions: accessConfig.permissions,
        scope: accessConfig.scope,
        expireIn: accessConfig.exp
    };
};

/**
 * Formatea la información del QR escaneada
 * @param {Object} data Información en formato JSON del QR
 */
export const extractQrInfo = ( data ) => {

    const qrData = {

        expiredIn: data.expiredIn,
        transactionId: data.transactionId,        
        subscriberUserData: {
            ...data.subscriberUserData
        }
    };

    if ( data.benefitId ) {

        qrData['benefitId'] = data.benefitId;
    }

    return qrData;
};